<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">{{ $t(`${namespace}.newProject`) }}</span>
        <v-btn class="v-dialog--custom__close mr-2" fab flat color="gray-6" :disabled="isLoading" @click="close">
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <form @submit.prevent="handleSubmit" class="form--custom" novalidate>
        <div>
          <v-card-text class="px-4 pt-0">
            <label>{{ `${$t(`${namespace}.fieldNameLabel`)}` }}</label>
            <v-text-field
              v-model="project.name"
              :placeholder="`${$t(`${namespace}.fieldNamePlaceholder`)} *`"
              :error-messages="errors.collect($t(`${namespace}.fieldName`))"
              v-validate="'required'"
              :data-vv-name="$t(`${namespace}.fieldName`)"
              required
              flat
              outline
              solo
              color="accent"
            />

            <label>{{ $t(`${namespace}.fieldCompanyLabel`) }}</label>
            <AutoComplete
              v-if="visible"
              kind="company"
              :data="company"
              :placeholder="$t(`Views.CostCenterPage.fieldCompanyPlaceholder`)"
              :isValid="isCompanyValid"
              required
              @input="updateCompany"
            />

            <label>{{ `${$t(`${namespace}.attachCostCenter`)}` }}</label>
            <AutoComplete
              kind="costCenter"
              :companyId="project.companyId || null"
              :placeholder="$t('Components.EmployeeForm.costCenter')"
              multiple
              @input="updateConstCenter"
            />
          </v-card-text>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <a
            v-if="!isLoading"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="close"
          >
            {{ $t('Common.cancel') }}
          </a>
          <v-btn
            type="submit"
            :disabled="isLoading || isDisabled"
            :loading="isLoading"
            round
            depressed
            color="accent"
          >
            {{ $t(`${namespace}.newProject`) }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isArray, isObject } from 'utils/functions'
import AutoComplete from 'components/AutoComplete'

export default {
  name: 'NewProjectDialog',
  components: {
    AutoComplete
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Components.ProjectForm',
      isLoading: false,
      isDisabled: false,
      isCompanyValid: true,

      // payload
      new: true,
      project: {
        name: null,
        companyId: null,
        costCenters: null
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    },

    close () {
      this.$emit('close')
    },

    updateCompany (val) {
      if (!this.isValidObject(val)) {
        this.project.companyId = null
        this.isCompanyValid = false
        return
      }

      this.project.companyId = val.id
      this.isCompanyValid = true
    },

    updateConstCenter (val) {
      if (!this.isValidArray(val)) {
        this.project.costCenters = []
        return
      }

      this.project.costCenters = val.map(item => item.id)
    },

    resetAllFields () {
      this.isLoading = false
      this.isDisabled = false
      this.isCompanyValid = true

      // payload
      this.new = true
      this.project = {
        name: null,
        companyId: null,
        costCenters: null
      }
    },

    async handleSubmit () {
      if (!this.project.companyId) {
        this.isCompanyValid = false
      }

      try {
        const isValid = await this.$validator.validateAll()

        if (!isValid || !this.project.companyId) return

        this.isLoading = true

        await this.$apiService.addProject(this.project)
        this.$emit('close', true)
        this.successAlert(this.$t(`${this.namespace}.success`))
        this.isLoading = false
      } catch (err) {
        console.log('Error', err)
        this.isLoading = false

        if (err) {
          const key = Object.keys(err.response.data.errors)[0]
          this.errorAlert(err.response.data.errors[key][0])
          return
        }

        this.errorAlert(this.$t(`${this.namespace}.error`))
      }
    }
  },
  watch: {
    company (val) {
      if (!val) {
        this.isCompanyValid = false
        return
      }

      this.isCompanyValid = true
    },

    visible (val) {
      this.resetAllFields()
      this.company && this.updateCompany(this.company)
      val && this.$ga.page('/dialog/projetos/adicionar')
    }
  }
}
</script>
